import React, { SVGProps } from "react";
import { useTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

const NewLookSuccessIllustration = (props: SVGProps<SVGSVGElement>) => {
  const { colors } = useTheme();
  return (
    <svg viewBox="0 0 160 120" fill="none" aria-hidden="true" {...props}>
      <circle cx="80" cy="60" r="56" fill={hexToRGB(colors.green, 0.06)} />
      <circle cx="80" cy="60" r="40" fill={hexToRGB(colors.green, 0.1)} />
      <circle cx="26" cy="36" r="3" fill={hexToRGB(colors.primaryBlue, 0.3)} />
      <circle cx="136" cy="30" r="2.5" fill={hexToRGB(colors.green, 0.45)} />
      <circle
        cx="130"
        cy="92"
        r="3.5"
        fill={hexToRGB(colors.primaryBlue, 0.2)}
      />
      <circle cx="34" cy="90" r="2" fill={hexToRGB(colors.green, 0.4)} />
      <circle cx="80" cy="60" r="24" fill={colors.green} />
      <path
        d="M69.5 60.5l7 7 14-15"
        stroke={colors.white}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NewLookSuccessIllustration;
